import { HTMLAttributes, ReactNode } from 'react';
import styled, { css } from 'styled-components';

import { Size } from 'coreOld/enums';

type WrapperBlockProps = HTMLAttributes<HTMLDivElement> & {
  children?: ReactNode;
  hideBorderBottom?: boolean;
  buttonWrapper?: boolean;
  inputsWrapper?: boolean;
  noContent?: boolean;
  noSidePadding?: boolean;
  size?: Size;
};

const WrapperBlock = styled.div<WrapperBlockProps>`
  padding: 15px 30px;
  border-bottom: ${({ theme }) => `1px solid ${theme.palette.text.secondary}`};

  ${({ hideBorderBottom }) =>
    hideBorderBottom &&
    css`
      border-bottom: none;
    `}

  ${({ buttonWrapper }) =>
    buttonWrapper &&
    css`
      padding: 30px;
    `}

  ${({ inputsWrapper }) =>
    inputsWrapper &&
    css`
      padding: 15px 30px 20px 30px;
    `}

  ${({ noContent }) =>
    noContent &&
    css`
      padding: 15px 30px 20px 30px;
      border-bottom: none;
    `}

  ${({ noSidePadding }) =>
    noSidePadding &&
    css`
      padding: 15px 0;
    `}

  ${({ size }) => {
    switch (size) {
      case Size.MD:
        return css`
          display: -ms-grid;
          display: grid;
          -ms-grid-columns: 1fr 1fr;
          grid-template-columns: 1fr 1fr;
          column-gap: 4em;
        `;
      default:
        return css``;
    }
  }};
`;

export default WrapperBlock;
